<template>
  <div>
    <!--<el-tooltip  placement="top" effect="light">-->
      <!--<div slot="content">{{row}}</div>-->
      <!--<span style="cursor: default">{{this.newDate}}</span>-->
    <span style="cursor: default">{{this.newDate}}</span>
      <!--<router-link  :to="{path:path,query:query}" v-else class="link">{{row}}</router-link>-->
    <!--</el-tooltip>-->
  </div>
</template>
<script>

  import dayjs from 'dayjs'
  export default {
    props:['row'],
    name: 'dateTimeToDate',
    data(){
      return {
        newDate:''
      }
    },
    created(){
      this.newDate = this.row?dayjs(this.row).format('YYYY-MM-DD'):''
    }
  }
</script>

<style scoped>
  .link{
    color: #458EF5;
    text-decoration: underline;
  }
</style>

